import React from "react";
import Navbar from "./navbar";
import Footer from "./Footer";
import { useLocation } from "react-router-dom";
import { RoutesWeb } from "../tools/RoutesWeb";
import NavbarGroup from "./navbarGroup";
import NavbarAdmin from "./navbarAdmin";

function Layout(props) {
  const location = useLocation();

  return (
    <>
      {(location.pathname === RoutesWeb.REGISTER_GROUP || location.pathname === RoutesWeb.REGISTER_GROUP_THANKS) ? 
        <NavbarGroup />
        :
        (location.pathname === RoutesWeb.ADMIN_LOGIN || 
          location.pathname === RoutesWeb.ADMIN_ADD_LEADER ||
          location.pathname === RoutesWeb.ADMIN_LEADERS ||
          location.pathname === RoutesWeb.ADMIN_DASHBOARD)
        ? <NavbarAdmin />
        :
        <Navbar />
      }
      <div className="container">{props.children}</div>
      <Footer />
    </>
  );
}

export default Layout;